import type { AnyAction } from '@reduxjs/toolkit';
import { ELECTION_ACTION_TYPES, loadElections, type PollworkerElection } from 'pollworker/src/state/actions/election';

export type ElectionState = {
  electionId: string;
  elections: PollworkerElection[] | null;
  loading: boolean;
};

const initialState: ElectionState = {
  electionId: '',
  elections: null,
  loading: false,
};

export default function electionReducer(state = initialState, action: AnyAction): ElectionState {
  switch (action.type) {
    case ELECTION_ACTION_TYPES.SET_ELECTION_ID:
      return {
        ...state,
        electionId: action.payload,
      };
    case loadElections.pending.type:
      return {
        ...state,
        loading: true,
      };
    case loadElections.fulfilled.type:
      return {
        ...state,
        loading: false,
        elections: action.payload ?? [],
      };
    case loadElections.rejected.type:
      return {
        ...state,
        loading: false,
        elections: [],
      };
    default:
      return state;
  }
}
